import Vue from 'vue'

export default {
  setError(state, { field, error }) {
    Vue.set(state.errors, field, error)
  },
  setDefaultError(state, error) {
    Vue.set(state, 'defaultError', error)
  },
  setLoading(state, loading) {
    Vue.set(state, 'isLoading', loading)
  },
}
